import { Lock } from "lucide-react";
import StudentAuth from "./StudentAuth";
import type { StudentDto } from "../lib/api";

// The sign-in wall: guests see ONLY this. Every page, the menu, the budget and
// the polls stay locked until a student signs in.
export default function AccessGate({ onSignedIn }: { onSignedIn: (s: StudentDto) => void }) {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="mx-auto flex min-h-screen max-w-3xl flex-col justify-center px-5 py-16">
        <p className="font-manrope text-[13px] uppercase tracking-[0.3em] text-[#AFDDFF]/80">
          BBA Freshers 2026
        </p>
        <div className="mt-6 rounded-xl border border-[#AFDDFF]/40 bg-[#AFDDFF]/[0.08] p-5">
          <div className="flex items-center gap-3">
            <Lock className="h-5 w-5 shrink-0 text-[#AFDDFF]" aria-hidden="true" />
            <h1 className="text-xl font-semibold leading-snug text-white md:text-2xl">
              To access the website content, first you have to sign in.
            </h1>
          </div>
          <p className="mt-3 text-sm leading-relaxed text-white/65">
            The event details, menu, voting and budget are available to registered BBA students
            only. Sign up once with your student details — every vote is linked to your identity,
            so no ballot numbers are needed.
          </p>
        </div>

        <div className="mt-8">
          <StudentAuth onSignedIn={onSignedIn} />
        </div>

        <p className="mt-8 text-xs leading-relaxed text-white/45">
          Organizing committee? Use the{" "}
          <a href="/admin/login" className="text-[#AFDDFF] hover:underline">
            committee login
          </a>
          .
        </p>
      </div>
    </div>
  );
}
